import { Text } from '@thanx/uikit/text'
import { buildTranslate } from 'locales'
import React from 'react'
import { useStyletron } from 'styletron-react'

const t = buildTranslate('recovery_ai.overview.no_guest_facing')

const VERTICAL_PADDING = '48px'

// Embedded empty state for the Overview tab's `none` stage — a single line, no
// CTA (the Turn-on billboard above it is the call to action).
const NoGuestFacingLocations = () => {
  const [css] = useStyletron()
  return (
    <div
      className={css({
        paddingTop: VERTICAL_PADDING,
        paddingBottom: VERTICAL_PADDING,
        textAlign: 'center',
      })}
    >
      <Text.BodyText3 color="grey70">{t('message')}</Text.BodyText3>
    </div>
  )
}

export default NoGuestFacingLocations
